/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';

import {
  IItemSpecMercuryProps,
  ItemSpecMercuryWidget,
} from '@vlinder-web/item-spec-mercury-widget-react';

export const HeroSection = (props: IItemSpecMercuryProps) => {
  return (
    <>
      <ItemSpecMercuryWidget
        {...props}
        timelineCardClick={props?.timelineCardClick}
      />
    </>
  );
};

HeroSection.defaultProps = {};
